import { z } from 'zod';

export const GameStatesSchema = z.object({
  moves: z.string().array(),
  disclosures: z.object({ index: z.number(), value: z.number(), hash: z.string() }).array(),
  lastCheckpointId: z.string().nullable(),
});
export type GameStatesData = z.infer<typeof GameStatesSchema>;
